import { FunctionComponent, PropsWithChildren } from 'react';

interface DashboardWidgetTitleProps extends PropsWithChildren {}

const DashboardWidgetTitle: FunctionComponent<DashboardWidgetTitleProps> = ({ children }) => {
  return <div className="text-md p-2  font-bold">{children}</div>;
};

export default DashboardWidgetTitle;
